import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { observer } from 'mobx-react';
import b from 'b_';
import { FTBody, Card } from '../../Fuse';
import BrowserIsolationOptionsStore, {
    REGISTRATION_TYPE
} from '../../../stores/Policy/BrowsingRoles/BrowserIsolationOptionsStore';
import PolicySection from '../PolicySection';
import AllowAnonymousRegistrationField from './AnonymousRegistrationField';
import RegistrationStatusField from './RegistrationStatusField';
import RegistrationTypeField from './RegistrationTypeField';
import ResearchModeField from './ResearchModeField';
import FuseAlert from '../../FuseControls/FuseAlert';
import './BrowserIsolationOptions.css';

const block = b.lock('BrowserIsolationOptions');

class BrowserIsolationOptions extends Component {
    static propTypes = {
        store: BrowserIsolationOptionsStore.PropType.isRequired,
        readOnly: PropTypes.bool,
        isSSOEnabled: PropTypes.bool,
    };

    render() {
        const { store, readOnly, isSSOEnabled } = this.props;

        return <Card title="Browser/Email Isolation Options">
            <PolicySection className={block('Section')}>
                {!isSSOEnabled && store.browserAuthenticationMethod.getValue() === REGISTRATION_TYPE.SAML_SSO ?
                    <FuseAlert
                        type={'warning'}
                        title={'Warning -'}
                        className={block('SSODisabledWarning')}
                        subtitle={'SAML is not enabled. The SSO operation will fail if users try to register' +
                        ' browsers via SSO. To set up Isolation to use SAML/SSO, please go to ' +
                        'Product Settings - SAML/SSO Configuration.'}
                    /> : null}
                <FTBody className={block('Heading')}>Browser Registration</FTBody>
                <div className={block('Field')}>
                    <RegistrationStatusField
                        store={store.browserRegistrationEnabled}
                        info={'Allow the registration of new Browser/Email users.' +
                        ' If disabled, any previously registered browsers will remain active'}
                        readOnly={readOnly}
                    />
                </div>
                {store.browserRegistrationEnabled.getValue() ? <Fragment>
                    <div className={block('Field')}>
                        <AllowAnonymousRegistrationField
                            store={store.anonymousUsage}
                            info={'If enabled, Browser and Email Isolation users will have their activity ' +
                            'anonymized for reporting purposes. This option can be enabled to help with GDPR ' +
                            'personal browsing use cases.'}
                            readOnly={readOnly}
                        />
                    </div>
                    <div className={block('Field')}>
                        <RegistrationTypeField
                            store={store.browserAuthenticationMethod}
                            info={'Specify the mechanism to use for new Browser/Email registrations.'}
                            readOnly={readOnly}
                        />
                    </div>
                </Fragment> : null}
            </PolicySection>
            <PolicySection className={block('Section')}>
                <FTBody className={block('Heading')}>Research Tools</FTBody>
                <div className={block('Field')}>
                    <ResearchModeField
                        store={store.allowResearchMode}
                        readOnly={readOnly}
                    />
                </div>
            </PolicySection>
        </Card>;
    }
}

export default observer(BrowserIsolationOptions);
